import React from 'react'

const SubsidyDetails = () => {
  return (
    <div>SubsidyDetails</div>
  )
}

export default SubsidyDetails